import Repository from './Repository';

const resource = '/address';

export default {
    getCities() {
        return Repository.get(`${resource}/cities`);
    },
    getCitiesByProvince(province) {
        return Repository.get(`${resource}/cities/`, { params: { province } });
    },
    getZones() {
        return Repository.get(`${resource}/zones`);
    },
    getZonesByCity(city) {
        return Repository.get(`${resource}/zones`, { params: { city } });
    }
}